import React from 'react';
import {BrowserRouter,Route,Routes} from 'react-router-dom';
import Site from './site/site.jsx';
import Login from './app/Login/login.jsx';
import NovaConta from './app/NovaConta/novaconta.jsx';
import ResetSenha from './app/ResetSenha/resetsenha.jsx';
import Home from './app/Home/home.jsx';
import NovoCliente from './app/NovoCliente/novocliente.jsx';
import EditarCliente from './app/EditarCliente/editarcliente.jsx';
import MostrarProcesso from './app/EditarCliente/mostrarprocesso.jsx';
import Carteira from './app/EditarCliente/carteira.jsx';
import Importar from './app/Importar/importar.jsx';
import Calendario from './app/Calendario/calendario.jsx';
import Filiar from './site/Components/filiar.jsx';
import ExplicarEproc from './app/EditarCliente/explicareproc.jsx';
import EditarProcesso from './app/EditarCliente/editarprocesso.jsx';

function App(){
    
    return <BrowserRouter>
    <Routes>
    <Route exact path='/' element={<Site/>} />
    <Route exact path='/app' element={<Login/>} />
    <Route exact path='/app/novaconta' element={<NovaConta/>} />
    <Route exact path='/app/resetsenha' element={<ResetSenha/>} />
    <Route exact path='/app/home' element={<Home/>} />
    <Route exact path='/app/novocliente' element={<NovoCliente/>} />
    <Route exact path='/app/importar' element={<Importar/>} />
    <Route exact path='/app/editarcliente/:id' element={<EditarCliente/>} />
    <Route exact path='/app/editarprocesso/:id' element={<EditarProcesso/>} />
    <Route exact path='/app/mostrarprocesso/:id' element={<MostrarProcesso/>} />
    <Route exact path='/app/carteira/:id' element={<Carteira/>} />
    <Route exact path='/app/calendario' element={<Calendario/>} />
    <Route exact path='/app/filiar' element={<Filiar/>} />

    </Routes>
    </BrowserRouter>;
    
  }

  export default App;